/* eslint-disable prefer-destructuring */
import styled, { css } from "styled-components";
import { type DisplayProps, type SpaceProps, display, space } from "styled-system";
import * as Flex from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import { ImageFluid } from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Image";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import * as CommonBasket from "../../../../../../../../common-deprecated/styles/v2/lexus/components/Basket";
import * as FinanceToggle from "../../../../../../../../common-deprecated/styles/v2/lexus/components/FinanceToggle";
import * as FinanceList from "../../../../../../../../common-deprecated/styles/v2/lexus/components/FinanceList";
import * as Type from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import * as Text from "../../../../../../../../common-deprecated/styles/v2/lexus/utilities/Text";
/* old components */
import * as BasketList from "./BasketList";
import * as MonthlyPrice from "../../price/styles/MonthlyPrice";
import * as CashPrice from "../../price/styles/CashPrice";
import { getBreakpoint, getDirection } from "../../../../../../../../common-deprecated/themes/common";
import * as Button from "../../../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import { h4Style, h6Style } from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";

export const BASKET_HEADER_TOP_MARGIN = theme.space[1];

export const Wrapper = styled.div<{ attached?: boolean } & SpaceProps>`
    background-color: ${theme.colors.mist};
    border-bottom: 0;
    ${space}
    @media ${getBreakpoint("up", "lg")} {
        padding: ${theme.space[3]}px;
    }
    ${CashPrice.Text} {
        color: ${theme.colors.midnight};
    }
    ${({ attached }) =>
        attached &&
        css`
            border-top: none;
        `}
`;

export const Inner = styled.div<{ hasBorderTop?: boolean } & SpaceProps>`
    padding: ${theme.space[3]}px;
    background-color: ${theme.colors.mist};
    ${space}
    @media ${getBreakpoint("up", "lg")} {
        padding: 0;
    }
    ${({ hasBorderTop }) =>
        hasBorderTop &&
        css`
            border-top: 1px solid ${theme.colors.platinumLight};
            @media ${getBreakpoint("up", "lg")} {
                margin-top: ${theme.space[3]}px;
                padding: ${theme.space[3]}px 0 0;
            }
        `}
`;

export const Title = CommonBasket.Title;

export const TitlePaymentSwitch = CommonBasket.TitlePaymentSwitch;

export const DescriptionPaymentSwitch = styled(CommonBasket.DescriptionPaymentSwitch)`
    margin-bottom: 0;
    &,
    ${MonthlyPrice.Text} {
        font-size: 1.5rem;
        line-height: 2.2rem;
        color: ${theme.colors.midnight};
    }
    ${Type.MicroText} {
        color: ${theme.colors.midnight};
    }

    /* overwriting the default styles here because of long buttons possible by innersethtml*/
    .btn-text-link > .btn-text {
        display: inline-block;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
`;

export const CarDetails = styled(CommonBasket.CarDetails)`
    margin-top: ${theme.space[1]}px;
    li {
        margin: 0;
    }
`;

export const FinanceQuotesWrapper = styled.div<DisplayProps>`
    ${display}

    &:not(:empty) {
        margin-top: ${theme.space[3]}px;
    }

    ${BasketList.BasketList} {
        padding: 0;
    }

    ${FinanceList.DescriptionTerm},
    ${FinanceList.DescriptionDetail} {
        color: ${theme.colors.midnight};
        border-top: 0 !important;
        border-bottom: 0 !important;
    }

    ${FinanceList.Header} {
        font-family: ${theme.fonts.regular};
        font-size: 1.5rem;
        line-height: 2rem;
        color: ${theme.colors.platinumDark};
    }

    ${FinanceList.DescriptionDetail} {
        font-family: ${theme.fonts.regular};
        font-size: 1.4rem;
    }

    ${FinanceList.DescriptionTerm} {
        font-family: ${theme.fonts.book};
        font-size: 1.6rem;
        line-height: 2.2rem;
    }

    ${BasketList.BasketListItem} {
        margin: 0;
        padding-top: ${theme.space[1]}px;
        padding-bottom: ${theme.space[1]}px;

        ${Flex.Col} {
            padding: 0;
        }
    }

    ${BasketList.ListItemLabel},
    ${BasketList.ListItemValue} {
        font-size: 1.3rem;
        line-height: 2.2rem;
        color: ${theme.colors.midnight};
    }
`;

export const PaymentDetailsWrapper = styled.div<{ isRTL?: boolean }>`
    margin-top: ${theme.space[3]}px;
    margin-bottom: ${theme.space[2]}px;

    dl {
        display: flex;
        flex: 0 0 100%;
        flex-flow: row wrap;
    }

    dt,
    dd {
        max-width: 100%;
        overflow-x: hidden;
        text-overflow: ellipsis;
    }

    dt {
        flex-basis: 50%;
        margin: 0;
        @media ${getBreakpoint("up", "lg")} {
            padding: 0;
        }
    }

    dd {
        flex-basis: 50%;
        margin: 0;
        @media ${getBreakpoint("up", "lg")} {
            padding: 0;
        }
    }
`;

export const DisclaimerWrapper = CommonBasket.DisclaimerWrapper;

export const CtaWrapper = styled.div`
    position: relative;
    margin-bottom: ${theme.space[1]}px;
`;

export const CtaLink = styled.a`
    display: block;
    width: 100%;
    padding: 12px;
    text-align: center;
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.platinumLight};
`;

export const CtaItem = styled.div<{ disabled?: boolean }>`
    display: flex;
    width: 50%;
    padding-bottom: ${theme.space[2]}px;
    padding-${getDirection("left")}: 15px;

    ${({ disabled }) =>
        disabled &&
        css`
            ${CtaLink} {
                cursor: default;
            }
        `}

    @media ${getBreakpoint("up", "lg")} {
        width: 25%;
    }
`;

export const CtaItems = styled.div<{ numItems?: number }>`
    display: flex;
    flex-wrap: wrap;
    margin: 0 0 0 -15px;
    /* Exception for when only two items */
    ${({ numItems }) =>
        numItems === 2 &&
        css`
            ${CtaItem} {
                @media ${getBreakpoint("up", "lg")} {
                    width: 50%;
                }
            }
        `};
    /* Exception for only three items */
    ${({ numItems }) =>
        numItems === 3 &&
        css`
            ${CtaItem} {
                @media ${getBreakpoint("up", "lg")} {
                    width: 33.3333%;
                }
            }
        `};
`;

export const CtaTitle = styled.span`
    display: block;
    margin-top: ${theme.space[1] / 2}px;
    font-family: ${theme.fonts.bold};
    font-size: 0.9rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    line-height: 1.2rem;
    text-transform: uppercase;
`;

export const EtaWrapper = styled.div`
    ${Text.Button} {
        text-align: ${getDirection("left")};
    }
`;

export const CarImage = styled(ImageFluid)`
    @media ${getBreakpoint("up", "lg")} {
        display: none;
    }
`;

export const BasketTitle = styled.h2`
    margin: 0;
    color: ${theme.colors.black};
    ${h4Style};
`;

export const BasketSubTitle = styled.h3`
    margin: 0;
    color: ${theme.colors.platinumDark};
    ${h6Style};
`;

export const BasketHeaderWrapper = styled.div<{ hideOnMobile?: boolean }>`
    text-align: ${getDirection("left")};

    ${({ hideOnMobile }) =>
        hideOnMobile &&
        css`
            @media ${getBreakpoint("down", "lg")} {
                display: none;
            }
        `}
`;

export const BasketHeader = styled.div<{ isRTL?: boolean } & DisplayProps>`
    margin-bottom: ${BASKET_HEADER_TOP_MARGIN}px;
    padding: ${theme.space[3]}px;
    background-color: ${theme.colors.mist};
    ${display};

    ${FinanceToggle.Wrapper} + dl {
        margin: ${theme.space[2]}px 0 0;
    }

    dl {
        display: flex;
        flex-wrap: wrap;
    }

    dt,
    dd {
        max-width: 100%;
        padding: ${theme.space[1]}px 0;
        font-size: 1.8rem;
        line-height: 2.43rem;
        text-overflow: ellipsis;
        color: ${theme.colors.midnight};

        &:not(:first-of-type) {
            border-top: 1px solid ${theme.colors.platinumLight};
        }
    }

    dt {
        width: 50%;
        font-family: ${theme.fonts.book};
        font-size: 1.8rem;
        font-weight: 400;

        ${({ isRTL }) =>
            isRTL &&
            css`
                width: 100%;
            `};
    }

    dd {
        flex-grow: 1;
        width: 50%;
        margin-${getDirection("left")}: 0 !important;
        font-family: ${theme.fonts.regular};
        font-size: 1.4rem;
        line-height: 1.89rem;
        text-align: ${getDirection("right")};
        &:first-of-type {
            text-transform: uppercase;
        }

        ${MonthlyPrice.MonthlyRateItems} {
           align-items: flex-end;
        }

        ${MonthlyPrice.MonthlyRateItem} { 
            &, ${MonthlyPrice.Text} {
                width: 100%;
            }
        }

        ${MonthlyPrice.Text} {
            text-overflow: ellipsis;
            white-space: normal;
            overflow: hidden;
         }

        ${({ isRTL }) =>
            isRTL &&
            css`
                width: 100%;
                text-align: right;
            `};
    }
`;

export const HeaderCtaWrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.space[3]}px;
    margin-top: ${theme.space[3]}px;

    ${Button.ButtonPrimary} {
        display: inline-block;
    }

    ${Button.ButtonWithIcon} + ${Button.ButtonPrimary} {
        margin-top: 0;
    }
`;
